import * as Sentry from '@sentry/browser';
import { SENTRY_IGNORE_URLS, filterNoiseFetchCall } from './utils/breadcrumb';

const KDS_SENTRY_DSN =
  'https://8764e248cca248e3855dc8b1d7279c57@o314552.ingest.us.sentry.io/4504094594433024';

const environment =
  process.env['REACT_APP_LOGGING_ENV'] || process.env.NODE_ENV || 'development';

if (!['local', 'development'].includes(environment)) {
  Sentry.init({
    denyUrls: SENTRY_IGNORE_URLS,
    dsn: KDS_SENTRY_DSN,
    environment: environment,
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    replaysOnErrorSampleRate: 1,
    replaysSessionSampleRate: 0,
    integrations: [
      Sentry.breadcrumbsIntegration({
        xhr: false,
        dom: {
          serializeAttribute: ['data-testid', 'textContent'],
        },
      }),
      Sentry.httpClientIntegration(),
      Sentry.inboundFiltersIntegration({
        ignoreErrors: [
          'Failed to fetch',
          'Network request failed',
          'AbortError',
          'Load failed',
          "Failed to execute 'readText' on 'Clipboard'",
        ],
      }),
    ],
    beforeBreadcrumb: breadcrumb => {
      return filterNoiseFetchCall(breadcrumb);
    },
  });
}

export default Sentry;
